import { useState, useEffect } from "react";
import { Form, Spin, Row, Col, Input, Select, DatePicker, Checkbox, Modal } from "antd";


import dayjs from 'dayjs';

import type { IEnum, IPlanoBeneficios, ISelectList, ITipo } from "../../../components/Interfaces";

import { carregaListaFundamentacaoLegal, carregaListaCaracteristica, carregaListaModalidade, carregaListaTipoRegulamento, carregaListaTipoInstituto, carregaListaUnidadeMedidaPercentualMonetario } from "../../PessoaJuridica/services";
import { maskCNPB, maskCurrency, maskNumeroProcesso } from "../../../utils/maskFunctions";
import { PatternFormat } from "react-number-format";


interface IProps {
  dadosPlano: IPlanoBeneficios | undefined;
  modalPlanoSucessoAberto: boolean;
  setModalPlanoSucessoAberto: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalPlano = ({ dadosPlano, modalPlanoSucessoAberto, setModalPlanoSucessoAberto }: IProps) => {
  const [form] = Form.useForm();

  const [listFundamentacaoLegal, setListFundamentacaoLegal] = useState<ISelectList[]>([]);
  const [listCaracteristicas, setListCaracteristicas] = useState<ISelectList[]>([]);
  const [listModalidades, setListModalidades] = useState<ISelectList[]>([]);
  const [listUnidadesMedidaContribuicaoMinima, setListUnidadesMedidaContribuicaoMinima] = useState<ISelectList[]>([]);
  const [listTipoRegulamento, setListTipoRegulamento] = useState<ISelectList[]>([]);
  const [listTipoInstituto, setListTipoInstituto] = useState<ITipo[]>([]);

  const [permiteAdesaoDependente, setPermiteAdesaoDependente] = useState(false);
  const [preveInscricaoAutomatica, setPreveInscricaoAutomatica] = useState(false);
  const [preveContribuicaoMinima, setPreveContribuicaoMinima] = useState(false);

  const [numeroProcessoPlanoFormato, setNumeroProcessoPlanoFormato] = useState("#####.######/####-##")

  useEffect(() => {
    window.scrollTo(0, 0)

    setLoading(true);
    const carregaDadosIniciais = async () => {
      carregaListaFundamentacaoLegalOpcoes();
      carregaListaCaracteristicasOpcoes();
      carregaListaModalidadesOpcoes();
      carregaListaUnidadesMedidaPercentualMonetarioOpcoes();
      carregaListaTiposRegulamentosOpcoes();

      carregaListaTiposInstitutosOpcoes();
    }
    carregaDadosIniciais();
    setLoading(false);
  }, []);

  useEffect(() => {

    if (dadosPlano && listCaracteristicas.length > 0 && listTipoRegulamento.length > 0
      && listModalidades.length > 0 && listFundamentacaoLegal.length > 0
      && listUnidadesMedidaContribuicaoMinima.length > 0 && listTipoInstituto.length > 0
    ) {
      setPermiteAdesaoDependente(dadosPlano.permiteAdesaoDependente);
      setPreveInscricaoAutomatica(dadosPlano.preveInscricaoAutomatica);
      setPreveContribuicaoMinima(dadosPlano.preveContribuicaoMinima);

      if (dadosPlano.pessoaJuridicaPlano?.numeroProcesso?.length !== 15)
        setNumeroProcessoPlanoFormato("####################");

      form.setFieldsValue({
        efpcNumeroEfpcCnpj: dadosPlano.efpc?.numeroPessoaJuridica,
        efpcNumeroProcesso: maskNumeroProcesso(dadosPlano.efpc?.pessoaJuridicaEfpc?.numeroProcesso),
        efpcRazaoSocial: dadosPlano.efpc?.pessoaJuridicaEfpc?.razaoSocial,

        planoNumeroEfpcCnpj: dadosPlano.pessoaJuridicaPlano?.tipoIdentificador === 1 ? dadosPlano.pessoaJuridicaPlano.numero : undefined,
        planoNumeroEfpcProcesso: dadosPlano.pessoaJuridicaPlano?.tipoIdentificador === 3 ? dadosPlano.pessoaJuridicaPlano?.numero : undefined,

        numeroProcesso: dadosPlano.pessoaJuridicaPlano?.numeroProcesso,

        dataAutorizacao: dadosPlano.dataAutorizacao ? dayjs(dadosPlano.dataAutorizacao).format("DD/MM/YYYY") : undefined,
        nome: dadosPlano.nome,
        numero: maskCNPB(dadosPlano.numero),
        sigla: dadosPlano.sigla.toUpperCase(),
        nmCaracteristica: listCaracteristicas.find(l => l.value === dadosPlano.caracteristica)?.label,
        nmModalidade: listModalidades.find(l => l.value === dadosPlano.modalidade)?.label,
        nmFundamentacaoLegal: listFundamentacaoLegal.find(l => l.value === dadosPlano.fundamentacaoLegal)?.label,

        nmTpRegulamento: listTipoRegulamento.find(l => l.value === dadosPlano.tipoRegulamento)?.label,
        codigoModelo: dadosPlano.codigoModelo?.toUpperCase(),
        contribuicaoMinima: dadosPlano.contribuicaoMinima ? maskCurrency(dadosPlano.contribuicaoMinima) : undefined,
        nmUnidadeMedidaContribuicaoMinima: listUnidadesMedidaContribuicaoMinima.find(l => l.value === dadosPlano.unidadeMedidaContribuicaoMinima)?.label,

        dataInicioFuncionamento: dadosPlano.dataInicioFuncionamento ? dayjs(dadosPlano.dataInicioFuncionamento) : undefined,

      });
    }
  }, [dadosPlano, listCaracteristicas, listTipoRegulamento, listModalidades, listFundamentacaoLegal, listUnidadesMedidaContribuicaoMinima, listTipoInstituto]);

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const carregaListaTiposInstitutosOpcoes = async () => {
    //    let listaLocal: any = [];
    await carregaListaTipoInstituto().then((response) => {
      // response.data.forEach((p: ITipo) => {
      //   listaLocal.push({ id: p.id, label: p.nome });
      // });
      setListTipoInstituto(response.data);
    });
  }

  const carregaListaTiposRegulamentosOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoRegulamento().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
      setListTipoRegulamento(listaLocal);
    });
  }

  const carregaListaFundamentacaoLegalOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaFundamentacaoLegal().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListFundamentacaoLegal(listaLocal);
  }

  const carregaListaCaracteristicasOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaCaracteristica().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListCaracteristicas(listaLocal);
  }

  const carregaListaModalidadesOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaModalidade().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListModalidades(listaLocal);
  }

  const carregaListaUnidadesMedidaPercentualMonetarioOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUnidadeMedidaPercentualMonetario().then((response) => {
      response.data.forEach((p: IEnum) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListUnidadesMedidaContribuicaoMinima(listaLocal);
  }

  const handleModalOk = () => {
    setModalPlanoSucessoAberto(false);
  };


  return (
    <>
    <Modal title="Plano de Benefícios"
      width={"80%"}
      closable={false}
      open={modalPlanoSucessoAberto} onOk={handleModalOk}
      cancelButtonProps={{ disabled: true }}>

        <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >

          <div className="main-content pl-sm-3 mt-4">
            <h1>Detalhar Plano de Benefícios</h1>
          </div>

          <Row>
            <Col xs={24} md={12} xl={5} hidden={dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador === 3}>
              <Form.Item
                label="CNPJ"
                name="planoNumeroEfpcCnpj">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7} hidden={dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador !== 3}>
              <Form.Item
                label="Identificador Provisório (Processo)"
                name="planoNumeroEfpcProcesso">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format={numeroProcessoPlanoFormato}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7} hidden={dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador !== 3}>
              <Form.Item
                label='CNPJ'
                name='cnpjNumero'>
                <Input maxLength={18} disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6} hidden={dadosPlano?.pessoaJuridicaPlano?.tipoIdentificador === 3}>
              <Form.Item
                label="Número do processo"
                name="numeroProcesso">
                <PatternFormat
                  customInput={Input}
                  format={numeroProcessoPlanoFormato}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data da Autorizacao"
                name="dataAutorizacao"
              >
                <Input disabled />
              </Form.Item>
            </Col>


            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data de início de Funcionamento"
                name="dataInicioFuncionamento">
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data de Encerramento"
                name="dataEncerramento"
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Código"
                name="numero"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Sigla"
                name="sigla"

              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={14}>
              <Form.Item
                label="Nome"
                name="nome"
              >
                <Input disabled />
              </Form.Item>
            </Col>

          </Row>

          <Row>
            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Característica"
                name="nmCaracteristica"
              >
                <Select
                  disabled
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Característica"
                  options={listCaracteristicas}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={10}>
              <Checkbox
                disabled
                checked={permiteAdesaoDependente}
              >
                Permite Adesão de Dependentes
              </Checkbox>
            </Col>

          </Row>

          <Row>
            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Modalidade"
                name="nmModalidade"
              >
                <Select
                  disabled
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Modalidade"
                  options={listModalidades}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={8}>
              <Form.Item
                label="Fundamentação Legal"
                name="nmFundamentacaoLegal"
              >
                <Select
                  disabled
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Fundamentação Legal"
                  options={listFundamentacaoLegal}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={10}>
              <Checkbox
                  disabled
                checked={preveInscricaoAutomatica}
              >
                Prevê Inscrição Automática
              </Checkbox>
            </Col>
          </Row>
        </Form>
      </Modal >
    </>
  );
};

export default ModalPlano;